// Module
var code = " <ng-template [cdkPortalOutlet]=\"currentStep\"></ng-template>";
// Exports
module.exports = code;